import { yupResolver } from '@hookform/resolvers/yup';
import moment from "moment-timezone";
import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Form, InputGroup, Row, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Helmet } from "react-helmet";
import { Controller, useForm } from 'react-hook-form';
import { FaPlus, FaSearch } from "react-icons/fa";
import Loader from "react-js-loader";
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { Link, useNavigate, useParams } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import * as Yup from 'yup';
import Header from '../../Layout/Header';
import { alertService } from "../../Utils/AlertService/alert.service";
import BsAlert from "../../Utils/BsAlert";
import { getEndpointUrl } from "../../Utils/Common";
import ModalSelectInvoice from "../Invoice/ModalSelectInvoice";
import Error404 from '../Error404';

const UpdatePurchaseInvoice = () => {
    const [error404, setError404] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [saveLoading, setSaveLoading] = useState(false);
    const [options, setOptions] = useState({
        autoClose: true,
        keepAfterRouteChange: false
    });

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const navigate = useNavigate();

    const params = useParams();

    const [invoice, setInvoice] = useState([]);
    const [purchase, setPurchase] = useState([]);

    const [modalSelectOffer, setModalSelectOffer] = useState(false);

    const [dateSelected, setDateSelected] = useState(new Date());

    const fetchDataInvoice = useCallback(async (invoice_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/invoice/${invoice_id !== undefined ? invoice_id : 0}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setInvoice(json.results);
            }

            setLoading(false);
        });
    }, []);

    const fetchDataPurchase = useCallback(async (purchase_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/purchase/${purchase_id !== undefined ? purchase_id : 0}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setPurchase(json.results);
                setInvoice(json.results.invoice);
                let defaultValues = {};
                defaultValues.invoice_id = json.results.invoice_id;
                defaultValues.date = new Date(json.results.purchaseDate);
                defaultValues.amount = json.results.amountPaid;
                defaultValues.description = json.results.paymentDescription;
                reset({ ...defaultValues });
            } else {
                setError404(true);
            }

            setLoading(false);
        });
    }, []);

    const validationSchema = Yup.object().shape({
        date: Yup.string().required('Field harus diisi'),
        invoice_id: Yup.number().nullable().typeError("Field berupa angka").required('Field harus diisi'),
        amount: Yup.number().when('isBig', (isBig, schema) => {
            return isBig ? schema.max(invoice && invoice.amount, `Total pembayaran melebihi penagihan.`) : schema.max(25000);
        }).nullable().typeError("Field berupa angka").required('Field harus diisi'),
        description: Yup.string().required('Field harus diisi')
    });

    const { register, handleSubmit, reset, control, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });

    useEffect(() => {
        fetchDataPurchase(params.purchase_id);
    }, [params, fetchDataPurchase, reset]);

    useEffect(() => {
        let defaultValues = {};
        defaultValues.invoice_id = invoice.id;
        defaultValues.date = new Date(moment(invoice.invoiceDate).toDate());
        reset({ ...defaultValues });
    }, [invoice, purchase]);

    const onSubmit = data => {

        setSaveLoading(true);

        fetch(getEndpointUrl() + `/purchase/${params.purchase_id}`, {
            method: "PUT",
            body: new URLSearchParams({
                invoice_id: data.invoice_id,
                date: moment(data.date).format('YYYY-MM-DD'),
                amount: invoice.amount,
                amountPaid: data.amount,
                description: data.description,
                user_id: userLogin.id,
            }),
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setSaveLoading(false);
            if (json.status === 'ok') {
                alertService.success("Yeay, Perubahan berhasil disimpan.", options);
            } else {
                alertService.warning(json.message, options);
            }
        }).catch(error => {
            setSaveLoading(false);
        });
    };

    const onCallbackSelectInvoice = useCallback((e) => {
        fetchDataInvoice(e.id);
    }, []);

    return error404 ? <Error404 /> : (
        <>
            <Helmet>
                <title>Update Pembayaran</title>
            </Helmet>
            <Header />
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Container className="mt-5 mb-5">
                    <Row>
                        <Col md={7}>
                            <Row>
                                <Col md={12}>
                                    <strong>Update Pembayaran</strong>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <BsAlert />
                                </Col>
                            </Row>
                            <Row className="mt-3 mb-3">
                                <Col md={10}>
                                    <Form.Label>Tagihan :</Form.Label>
                                    <InputGroup>
                                        <Controller
                                            render={({ field }) => (
                                                <Form.Control {...field}
                                                    type="number"
                                                    placeholder="Pilih Tagihan"
                                                    readOnly
                                                    disabled
                                                    isInvalid={errors.invoice_id ? true : false} />
                                            )}
                                            control={control}
                                            defaultValue={invoice && invoice.id}
                                            name="invoice_id"
                                        />
                                        <Button variant="outline-secondary" onClick={(e) => setModalSelectOffer(true)}><FaSearch /> Cari</Button>
                                        <Link to="/invoice/create" className="btn btn-outline-secondary"><FaPlus /> Tambahkan</Link>
                                    </InputGroup>
                                    <ModalSelectInvoice onCallback={onCallbackSelectInvoice} show={modalSelectOffer} close={(e) => setModalSelectOffer(false)} />
                                    <Form.Text className="text-muted fs-13 clearfix">{errors.invoice_id?.message}</Form.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tanggal Pembayaran :</Form.Label>
                                        <Controller
                                            control={control}
                                            name="date"
                                            render={({ field }) => (
                                                <DatePicker
                                                    startDate={dateSelected}
                                                    minDate={invoice && new Date(invoice.invoiceDate)}
                                                    className={errors.date ? `is-invalid` : ``}
                                                    disabled={saveLoading}
                                                    isInvalid={errors.date ? true : false}
                                                    autoComplete="off"
                                                    onChange={(date) => {
                                                        field.onChange(date);
                                                        setDateSelected(date)
                                                    }}
                                                    selected={field.value}
                                                    customInput={<Form.Control />}
                                                />
                                            )}
                                        />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.date?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Total Pembayaran :</Form.Label>
                                        <Form.Control type="number" {...register("amount")} isInvalid={errors.amount ? true : false} disabled={saveLoading || isLoading} autoComplete="off" />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.amount?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Deskripsi :</Form.Label>
                                        <Form.Control type="text" as={'textarea'} rows={5}  {...register("description")} isInvalid={errors.description ? true : false} disabled={saveLoading} autoComplete="off" />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.description?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={12} className="d-flex justify-content-end">
                                    <Link to={"/pembayaran"} title="Batal" className="btn btn-secondary me-3">Batal</Link>
                                    <Button type="submit" disabled={saveLoading}>{saveLoading ? "Mengirim data..." : "Simpan Perubahan"}</Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={5}>
                            <strong>Tagihan</strong>
                            <Table className="mt-2 fs-13">
                                <tbody>
                                    <tr>
                                        <td className="text-muted" width={120}>Tagihan ID</td>
                                        <td className="text-center" width={20}>:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                invoice && invoice.id
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted" width={120}>Tanggal dibuat</td>
                                        <td className="text-center" width={20}>:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                <>
                                                    <strong><Moment format="D MMM YYYY">{invoice && invoice.createdAt}</Moment></strong>
                                                    <span className="text-muted fw-medium"><Moment format=" - HH:mm A">{invoice && invoice.createdAt}</Moment></span>
                                                </>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted" width={120}>Periode Penagihan</td>
                                        <td className="text-center" width={20}>:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                <>
                                                    <strong><Moment format="D MMM YYYY">{invoice && invoice.invoiceDate}</Moment></strong>
                                                    <span className="px-2">-</span>
                                                    <strong><Moment format="D MMM YYYY">{invoice && invoice.doeDate}</Moment></strong>
                                                </>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Nama Pelanggan</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-bold">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                invoice && invoice.customerName
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Email</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                invoice && invoice.customerEmail
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">No Handphone</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                invoice && invoice.customerPhone
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Alamat</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                invoice && invoice.customerAddress
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted" width={150}>Deskripsi</td>
                                        <td className="text-center" width={20}>:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                invoice && invoice.noteDescription
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Harga</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-bold">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                <NumericFormat
                                                    value={invoice ? invoice.amount : 0}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    prefix={'Rp'}
                                                    renderText={(value, props) => <span {...props}>{value}</span>} />
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
            </Form>
        </>
    );
}

export default UpdatePurchaseInvoice;